<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'Product-list'"
    :ref="'product-list'"
  >
    <template #popup>
      <gcPopupCopyProduct
        :visible="getCopyProductVisible"
        @setCopyProductVisible="setCopyProductVisible"
        :popUpConfig="popUpConfig"
        v-if="getCopyProductVisible"
        @reloadProductDetailData="loadProductDetailData"
        :displayServerError="displayServerErrorOnTemplate"
        :refresh-list="true"
      />
    </template>
  </TransactionListTemplate>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import DataGridMixin from "@/_mixins/data-grid.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
import { FeatureStorage } from "../../_services/storage";
import {
  ProductListTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/products/products-list-tabs";
import gcPopupCopyProduct from "../../popups/products/gc-popup-copy-product.vue";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin, DataGridMixin],
  components: {
    TransactionListTemplate,
    gcPopupCopyProduct,
  },
  data() {
    return {
      CopyProductVisible: false,
      popUpConfig: {},
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Products",
        exportFileName: "Products List",
        selectedIndex: GetIndexByTabName("All"),
        tabs: ProductListTabs(),
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "ProductList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              keyType: {
                Attribute01: "Guid",
                Attribute02: "Guid",
                Attribute03: "Guid",
                Attribute04: "Guid",
                Attribute05: "Guid",
                Attribute06: "Guid",
                Attribute07: "Guid",
                Attribute08: "Guid",
                Attribute09: "Guid",
                Attribute10: "Guid",
                Attribute11: "Guid",
                Attribute12: "Guid",
                Attribute13: "Guid",
                Attribute14: "Guid",
                Attribute15: "Guid",
                Attribute16: "Guid",
                Attribute17: "Guid",
                Attribute18: "Guid",
                Attribute19: "Guid",
                Attribute20: "Guid",
              },
            },
            // rowSelect: {
            //   view: this,
            //   page: "sales-order",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Products",
                message: "Get Started, Add a Product",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/product/create",
                clickAction: {},
                buttonLocation: "left",
                visible: FeatureStorage.checkPermission("Product", "create"),
              },
            ],
          },
          columns: [
            {
              screenField: "Item",
              label: "Product",
              gridDataField: "Description1",
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description1",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Item Code",
                },
                {
                  dataField: "Description1",
                  label: "Item Description 1",
                },
                {
                  dataField: "Description2",
                  label: "Item Description 2",
                },
                {
                  dataField: "Description3",
                  label: "Item Description 3",
                },
              ],
              fixed: true,
              fixedPosition: "left",
            },
            {
              dataField: "UnitOfMeasureCode",
              label: "Stock UM",
              width: 70,
            },
            {
              screenField: "Product",
              hyperLinkDataField: "Code",
              visible: false,
              showInColumnChooser: false,
            },
            {
              screenField: "OnHand",
              dataField: "TotalOnHand",
              label: "Total On Hand",
              hyperlink: {
                url: "report/product/grid/stock-summary",
                target: "_blank",
                params: ["Product"],
                zeroClickable: true,
              },
              width: 100,
            },
            {
              screenField: "Supplier",
              visible: false,
              showInColumnChooser: false,
              filterIndex: 3,
              filterDataRelationship: "Child",
              filterOperator: "=",
              filterDataField: "SupplierDataList/SupplierCode",
              gridDataField: "SupplierList",
            },
            {
              screenField: "Code",
              label: "Product Code",
              filterLabel: "Product Code",
              dataField: "Code",
              showInColumnChooser: false,
              visible: false,
              type: "Text",
            },
            {
              screenField: "Name",
              filterLabel: "Product",
              filterDataField: "ProductSearchText",
              showInColumnChooser: false,
              visible: false,
              type: "Text",
              filterIndex: 1,
            },
            {
              screenField: "ProductCategory1",
              label: "Category 1",
              filterLabel: "Category 1",
              filterIndex: 7,
            },
            {
              screenField: "ProductCategory2",
              label: "Category 2",
              filterLabel: "Category 2",
              filterIndex: 8,
            },
            {
              screenField: "ProductCategory3",
              label: "Category 3",
              filterLabel: "Category 3",
              filterIndex: 9,
            },
            {
              screenField: "ProductCategory4",
              label: "Category 4",
              filterLabel: "Category 4",
              filterIndex: 10,
            },
            {
              screenField: "ProductType",
              label: "Type",
              filterLabel: "Type",
              filterIndex: 11,
            },
            {
              screenField: "ProductSize",
              label: "Size",
              filterLabel: "Size",
              filterIndex: 12,
            },
            {
              screenField: "BatchMethod",
              visible: false,
              filterIndex: 4,
              width: 100,
            },
            {
              screenField: "ProductSource",
              visible: false,
              filterIndex: 5,
              filterDataField: "Source",
              width: 100,
            },
            {
              screenField: "AvailableForSale",
              visible: false,
              filterIndex: 6,
              filterDataField: "AvailableForSale",
              width: 120,
            },
          ]
            .concat(this.getAttributeColumns(12))
            .concat(
              {
                screenField: "Status",
                gridDataField: "Inactive",
                gridLabel: "Status",
                filterIndex: 2,
                filterDefaultValue: ["N"],
              },
              {
                screenField: "GridRecordEllipsisMenu",
                cssClass: "padding-7",
                width: 50,
                allowSearch: false,
                ellipsisMenu: {
                  itemAction: (data) => {
                    var items = [
                      {
                        menuText: "Copy Product",
                        data: data,
                        clickAction: this.setCopyProductVisible.bind(
                          this,
                          true
                        ),
                        visible: FeatureStorage.checkPermission(
                          "Product",
                          "create"
                        ),
                      },
                    ];

                    return items;
                  },
                  keyExpr: "menuText",
                  displayExpr: "menuText",
                },
                makeDisabled: () => {
                  return !FeatureStorage.checkPermission("Product", "create");
                },
              }
            ),
        },
      };

      return config;
    },

    /* Get Copy Product Popup Visible */
    getCopyProductVisible() {
      return this.CopyProductVisible;
    },
  },
  methods: {
    /* Generate Attribute Columns */
    // getAttributeColumns() {
    //   const records = [];

    //   for (let i = 1; i <= 20; i++) {
    //     const record = {
    //       screenField: `ProductAttribute${i.toString().padStart(2, "0")}`,
    //       label: `Attribute ${i.toString().padStart(2, "0")}`,
    //       filterLabel: `Attribute ${i.toString().padStart(2, "0")}`,
    //       cellTemplateRecord: {
    //         primary: [
    //           {
    //             dataField: `Attribute${i
    //               .toString()
    //               .padStart(2, "0")}Description`,
    //           },
    //         ],
    //         secondary: [
    //           {
    //             dataField: `Attribute${i.toString().padStart(2, "0")}Code`,
    //           },
    //         ],
    //       },
    //       exportFields: [
    //         {
    //           dataField: `Attribute${i.toString().padStart(2, "0")}Code`,
    //           label: `Attribute ${i.toString().padStart(2, "0")} Code`,
    //         },
    //         {
    //           dataField: `Attribute${i.toString().padStart(2, "0")}Description`,
    //           label: `Attribute ${i.toString().padStart(2, "0")} Description`,
    //         },
    //       ],
    //       filterIndex: 13,
    //       filterDataField: `Attribute${i.toString().padStart(2, "0")}`,
    //       visible: false,
    //     };

    //     records.push(record);
    //   }

    //   return records;
    // },

    /* Row Click Callback */
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu" &&
        e.column.screenField != "OnHand"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: "product",
          mode: "review",
          idProperty: "Code",
        });
      }
    },

    /* Set Copy Product Popup Visible */
    setCopyProductVisible(value, rowData) {
      if (rowData) {
        this.popUpConfig = {
          ProductCode: rowData.Code,
          Description1: rowData.Description1,
          Description2: rowData.Description2,
          Description3: rowData.Description3,
        };
      }
      this.CopyProductVisible = value;
    },

    /* Load Product Detail Data */
    loadProductDetailData() {
      this.$refs["product-list"].$refs["transactionListGrid"].gridRepaint();
    },

    /* Display Server Error On Template */
    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
